export default __webpack_public_path__ + "static/media/slide_background.b0f4fb84.svg";